// extracted by mini-css-extract-plugin
export default {"MarkdownContent":"styles--MarkdownContent--14U-m"};